<div class="flex flex-col lg:flex-row gap-3 p-3 h-full w-full overflow-hidden">
    <div class="w-full lg:w-[18.75rem] lg:min-w-[12.5rem] lg:shrink h-full overflow-hidden">
        <app-document-types-list [documentTypes]="docTypes" [docTypeLoading]="docTypeLoading"
            (documentTypeSelected)="onDocumentTypeSelected($event)" (refetchDocumentTypes)="getDocumentTypes()">
        </app-document-types-list>
    </div>
    <div class="w-full lg:flex-1 lg:min-w-0 flex flex-col gap-2 h-full min-h-0 overflow-hidden">
        <div class="flex flex-col sm:flex-row w-full justify-between items-start sm:items-center gap-3 flex-shrink-0">
            <div class="flex-1">
                <h2 class="font-bold text-lg sm:text-xl break-words">{{selectedDocType.name}}
                </h2>
            </div>
            <div class="items-center flex justify-end w-full sm:w-auto">
                <app-button variant="filled" severity="primary" label="Add Milestones" icon="pi pi-plus"
                    (clicked)="addMilestone()" />
            </div>
        </div>
        <div class="flex flex-col gap-2 overflow-y-auto flex-1 min-h-0">
            <div *ngFor="let milestone of milestoneOptions"
                class="flex flex-col sm:flex-row justify-between gap-2 items-stretch sm:items-center">
                <div class="border border-gray-300 rounded-base shadow-sm flex-1 p-1.5">
                    <span class="break-words">{{ milestone.name }}</span>
                </div>
                <div class="flex gap-2 flex-shrink-0 justify-end sm:justify-start">
                    <app-button variant="outlined" severity="contrast" icon="pi pi-pencil"
                        (clicked)="editMilestone(milestone)" />
                    <app-button variant="outlined" severity="danger" icon="pi pi-trash"
                        (clicked)="openDeleteDialog(milestone)" />
                </div>
            </div>
        </div>
    </div>
</div>

<app-dialog [(visible)]="addEditMilestoneVisible" [title]="(edit ? 'Edit' : 'Add') + ' Milestones'"
    (closed)="addEditMilestoneVisible = false" class="max-w-[500px]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex flex-col gap-2 p-4">
            <label for="name">Name <span class="text-danger">*</span></label>
            <input pInputText id="name" class="flex-auto border rounded-base input" autocomplete="off"
                [(ngModel)]="newMilestoneName" required #name="ngModel" />
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex gap-2 justify-end">
            <app-button variant="outlined" label="Cancel" severity="contrast" icon="pi pi-times"
                (clicked)="cancelAddMilestone()" />
            <app-button variant="filled" severity="primary" label="Save" icon="pi pi-save"
                (clicked)="saveNewMilestone()" [disabled]="!hasChanges" />
        </div>
    </ng-template>
</app-dialog>

@if(deleteMilestoneDialog){
    <app-delete-confirmation [(visible)]="deleteMilestoneDialog" width="90vw" [style]="{'max-width': '600px'}"
        bodyText="This milestone will be permanently deleted from the document type. Do you want to proceed with deleting this milestone?"
        confirmButtonText="Yes, Delete" (onConfirm)="deleteSelectedMilestone()">
        <ng-template #headerTemplate>
            <span class="flex items-center gap-2 text-lg">
                <i [innerHTML]="SVGS.RED_TRASH | sanitizeHtml" style="cursor: pointer;"></i>
                <span class="font-bold">Delete the milestone?</span>
            </span>
        </ng-template>
    </app-delete-confirmation>
}
